export const normalizeResolvedCustomerId = (value) => {
  if (value && typeof value === "object") {
    return (
      value.id ||
      value.customerId ||
      value.CustomerId ||
      value.customer?.id ||
      value.Customer?.id ||
      null
    );
  }
  return value || null;
};

export const resolveOrderFilesCustomerId = ({
  customerId: explicitCustomerId = null,
  order,
  store,
}) => {
  if (explicitCustomerId) {
    return normalizeResolvedCustomerId(explicitCustomerId);
  }
  if (order?.attachedCustomers?.[0]) {
    return normalizeResolvedCustomerId(order.attachedCustomers[0]);
  }
  if (store?.attachedCustomers?.[0]) {
    return normalizeResolvedCustomerId(store.attachedCustomers[0]);
  }

  return normalizeResolvedCustomerId(
    store?.AttachedCustomerId ||
      store?.attachedCustomerId ||
      store?.customerId ||
      store?.CustomerId ||
      store?.customer?.id ||
      store?.Customer?.id ||
      null
  );
};

export const supportsOrderFileImportSessions = ({
  instanceUniqueId,
  activeOrderId,
  customerLibraryMode = false,
}) => Boolean(instanceUniqueId && (activeOrderId || customerLibraryMode));

export const isCustomerLibraryMode = ({
  customerId = null,
  activeOrderId = "",
}) => Boolean(normalizeResolvedCustomerId(customerId) && !String(activeOrderId || "").trim());

export const getInitialSelectedFolder = () => "all";

export const buildFileRequestParams = ({
  destinationFolderId = null,
  selectedFolder = "all",
  activeOrderId = "",
  instanceUniqueId = "",
}) => ({
  folder:
    destinationFolderId || selectedFolder === "all"
      ? undefined
      : selectedFolder,
  folderId: destinationFolderId || undefined,
  orderId: activeOrderId || undefined,
  instanceUniqueId: instanceUniqueId || undefined,
  includeMeta: true,
});
